// extracted by mini-css-extract-plugin
export var copyableField = "_pa-4";
export var customerBadge = "_pa-0";
export var customerInfoTitle = "_pa-2";
export var details = "_pa-1";
export var dropdownContainer = "_pa-5";
export var dropdownImage = "_pa-6";
export var editAssigneeForm = "_pa-a";
export var editButton = "_pa-3";
export var email = "_pa-7";
export var hidden = "_pa-d";
export var input = "_pa-8";
export var saveButton = "_pa-b";
export var shopifyIcon = "_pa-c";
export var suggestionBadge = "_pa-e";
export var suggestionText = "_pa-f";
export var username = "_pa-9";